import type { FC, CSSProperties, MouseEventHandler } from 'react';
import { useCallback } from 'react';
import classNames from 'classnames';

import type { PutCartResponseDataCouponItemType } from '@/apis/product/index';
import { getCDNAssets } from '@/utils';

import styles from './styles/card.module.less';

export type CouponLimitListCardProps = {
  className?: string;
  style?: CSSProperties;
  item?: PutCartResponseDataCouponItemType;
  onRemove?: (item?: PutCartResponseDataCouponItemType) => unknown;
};

const CouponLimitListCard: FC<CouponLimitListCardProps> = (props) => {
  const { className, style, item, onRemove } = props;

  const handleDelClick = useCallback<MouseEventHandler<HTMLDivElement>>(
    (e) => {
      e.stopPropagation();
      onRemove?.(item);
    },
    [item, onRemove],
  );

  if (!item) {
    return null;
  }

  return (
    <div className={classNames(styles.wrapper, className)} style={style}>
      <div className={styles.cardShell}>
        <div
          className={styles.card}
          style={{ backgroundImage: `url(${getCDNAssets('lib_bg_coupon_conflict_error.png')})` }}>
          <div className={styles.cardLeft}>
            <img className={styles.cardLeftImg} src={item.image} />
            <div className={styles.cardContent}>
              <div className={styles.cardTitle}>{item.couponTitle}</div>
              {item.todayLeftCount && item.totalLeftCount && (
                <div className={styles.cardTimes}>
                  {`今日`}
                  <span className={styles.cardTimesNum}>{item.todayLeftCount}</span>次 ，总共
                  <span className={styles.cardTimesNum}>{item.totalLeftCount}</span>次
                </div>
              )}
              {item.timeRange && <div className={styles.couponTimeRange}>{item.timeRange}</div>}
            </div>
          </div>
          <div className={styles.cardActionDel} onClick={handleDelClick}>
            {item.button?.text || '移除'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponLimitListCard;
